import { render, staticRenderFns } from "./BookCostsList.vue?vue&type=template&id=707c8e11&scoped=true"
import script from "./BookCostsList.vue?vue&type=script&lang=js"
export * from "./BookCostsList.vue?vue&type=script&lang=js"
import style0 from "./BookCostsList.vue?vue&type=style&index=0&id=707c8e11&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707c8e11",
  null
  
)

export default component.exports